import React from 'react';
import { getTranslatedString } from 'helpers/i18n';
import Select from 'components/ui/SelectField';
import Form from 'components/ui/Form';
import Col from 'components/ui/Col';

const CategorySelect = ({ setFieldValue, value, categories, errors, touched, disabled }) => {
  return (
    <Col span={24}>
      <Form.Item
        label={`${getTranslatedString('landlordPortal.maintenance.category')}*`}
        validateStatus={touched.category && errors.category ? 'error' : null}
        help={touched.category && errors.category}
      >
        <Select
          placeholder={getTranslatedString('landlordPortal.maintenance.placeHolder.select')}
          size="large"
          value={value === '' ? undefined : value} // if value here is '' change to undefined to show placeholder
          onChange={value => {
            setFieldValue('category', value);
          }}
          disabled={disabled}
        >
          {categories &&
            categories.map((category, i) => (
              <Select.Option value={category.value} key={category.label}>
                {category.label}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>
    </Col>
  );
};

export default CategorySelect;
